export default "__VITE_ASSET__e5be118d__"